export enum AppMenuType {
	MenuItem = 0,
	Separator = 1,
}
